import { useContext, useEffect, useRef, useState } from "react";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import "../App.css";
import {
  Button,
  Col,
  FloatButton,
  Popover,
  Progress,
  Row,
  Space,
  Statistic,
  Tour,
  TourProps,
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import AddPatientModal from "../patients/AddPatientModal";
import AddExamModal from "../exams/AddExamModal";
import { emptyStudio, Studio } from "../studio/interfaces";
import { getStudio } from "../studio/utils";
import { getAllPatients } from "../patients/utils";
import PlusButton from "../buttons/plusbutton";
import PlusbuttonExam from "../buttons/plusbuttonexams";
import "./Home.css";
import { HOME_PATH, PRICE_PATH } from "../env";
import TinettiExam from "../exams/TinettiExam";
import { Footer } from "antd/es/layout/layout";
import Chat from "../assistente/chat";
import TutorialButtonYouTube from "../exams/TutorialButtonYouTube";

const Home = () => {
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  const [licenseVisible, setLicenseVisible] = useState(true);
  const [sizeVisible, setSizeVisible] = useState(false);
  const [addPatientVisible, setAddPatientVisible] = useState(false);
  const [addExamVisible, setAddExamVisible] = useState(false);
  const [width, setWidth] = useState(0);

  const [studio, setStudio] = useState(emptyStudio);
  const handleResize = () => setWidth(window.innerWidth);

  const [subscribedEnd, setSubscribedEnd] = useState<Date | null>(null); // Inizialmente null, sostituisci con la tua data di fine iscrizione
  const [daysRemaining, setDaysRemaining] = useState<number | undefined>(
    undefined
  );

  const [PatientX, setPatientX] = useState<number | undefined>(undefined);

  const [sizeRemaining, setSizeRemaining] = useState(0);

  useEffect(() => {
    // Verifica se studio.fbSizeMax è definito prima di utilizzarlo
    if (studio.fbSizeMax !== undefined) {
      // Utilizza direttamente studio.fbSizeMax che è già un numero
      const newSizeRemaining = studio.fbSizeMax - (studio.fbSize || 0);
      setSizeRemaining(Number(newSizeRemaining.toFixed(2))); // Converti in nu
      setSizeVisible(true);
    }
  }, [studio.fbSizeMax, studio.fbSize]);

  // console.log("Mancano: MB " + sizeRemaining);

  useEffect(() => {
    getStudio(signedInDoctor)
      .then((fetchedStudio: Studio) => {
        setStudio({
          ...fetchedStudio,
        });
      })
      .catch((err) => console.error(err));
  }, [signedInDoctor]);

  useEffect(() => console.log(studio), [studio]);
  useEffect(() => console.log(studio.patients), [signedInDoctor]);
  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (studio.subscribedEnd) {
      const currentDate = new Date();
      const endDate = new Date(studio.subscribedEnd);
      const timeDiff = endDate.getTime() - currentDate.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)); // Millisecondi in un giorno
      setDaysRemaining(daysDiff);
    }
  }, [studio.subscribedEnd]);

  let licenseStatus = "Scaduta"; // Impostiamo inizialmente su "Scaduta"

  if (typeof daysRemaining === "number") {
    if (daysRemaining > 18) {
      licenseStatus = "Attiva";
    } else if (daysRemaining > 0) {
      licenseStatus = "In Scadenza";
    }
  }

  //  console.log("Io Sono Doc Master? " + signedInDoctor.studioMaster);

  //  console.log(`Stato della licenza: ${licenseStatus}`);

  const percentComplete =
    daysRemaining !== undefined
      ? Math.round(((daysRemaining as number) / 365) * 100)
      : undefined;

  //  console.log(daysRemaining);

  useEffect(() => {
    getAllPatients(signedInDoctor).then((fetchedPatients) => {
      const totalPatients = fetchedPatients.length;
      // console.log(`Numero totale di pazienti: ${totalPatients}`);
      setPatientX(totalPatients);
    });
  }, [signedInDoctor]);

  const newPatient: JSX.Element = (
    <>
      <button className="traspaz" onClick={() => setAddPatientVisible(true)}>
        <PlusButton />
      </button>
      <AddPatientModal
        visible={addPatientVisible}
        setVisible={setAddPatientVisible}
      />
    </>
  );

  const newExam: JSX.Element = (
    <>
      <button className="traspaz" onClick={() => setAddExamVisible(true)}>
        <PlusbuttonExam />
      </button>

      <AddExamModal visible={addExamVisible} setVisible={setAddExamVisible} />
    </>
  );

  //Tour Mode

  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem("hasVisited");

    if (!hasVisited) {
      // Imposta lo stato del tour su true solo se l'utente non ha visitato l'app prima
      setShowTour(true);
      // Memorizza nello stato locale che l'utente ha visitato l'app
      localStorage.setItem("hasVisited", "true");
    }
  }, []);

  useEffect(() => {
    if (showTour == false) {
      () => setOpen(true);
      //  console.log("è " + setOpen);
    }
  }, []);

  const menupic =
    "https://www.physiocheck.it/wp-content/uploads/2024/02/physiocxhe-mernu.gif";

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);

  const [open, setOpen] = useState<boolean>(false);

  const steps: TourProps["steps"] = [
    {
      title: "Spazio Occupato",
      description:
        "In questa sezione, puoi mantenerti aggiornato sullo spazio utilizzato e controllare anche lo spazio rimasto.",

      target: () => ref1.current,
    },
    {
      title: "Pazienti Totali",
      description:
        "Qui troverai sempre aggiornato il numero dei tuoi pazienti.",
      target: () => ref2.current,
    },
    {
      title: "Stato Licenza",
      description:
        "Qui puoi trovare Lo stato attuale e il numero di giorni mancanti alla scadenza della tua licenza.",
      target: () => ref3.current,
    },
    {
      title: "Aggiungi Nuovo Paziente",
      description:
        "Cliccando su questo pulsante, potrai creare una nuova scheda paziente.",
      target: () => ref4.current,
    },
    {
      title: "Aggiungi Nuovo Esame",
      description:
        "Cliccando su questo pulsante, potrai creare un nuovo esame.",
      target: () => ref5.current,
    },
    {
      title: "Menu",
      description:
        "Nella parte sinistra, troverai il menu, che ti permetterà di navigare tra le varie sezioni del software.",
      cover: <img className="select" src={menupic} />,
      target: () => ref6.current,
    },
  ];

  const contentx = (
    <>
      <Row>
        <Button onClick={() => setOpen(true)}>Tour Guidato</Button>

        <Button href="https://www.physiocheck.it/richiesta-assistenza/">
          Contattaci
        </Button>
      </Row>
    </>
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSizeVisible(false);
      setLicenseVisible(false);
    }, 5000); // 10000 millisecondi = 10 secondi

    // Assicurati di cancellare il timeout quando il componente si smonta
    return () => clearTimeout(timeoutId);
  }, []); // L'effetto verrà eseguito solo una volta all'inizio

  //Tour Mode End

  return (
    <>
      <TutorialButtonYouTube
        video={"https://www.youtube.com/embed/N7n0APh1LiA?si=R8uu3NW_evMJHOr7"}
        title={"Tutorial PhysiocheckApp | Dashboard"}
      />
      <Tour open={open} onClose={() => setOpen(false)} steps={steps} />
      <div className="centered">
        <h3 className="section-title">
          Bentornato {signedInDoctor.name || signedInDoctor.username}!
        </h3>
      </div>
      {false && width}
      {daysRemaining !== undefined && daysRemaining < 16 && licenseVisible && (
        <>
          <Row id="Dodox" className="firstDodox">
            <div className="Dodox">
              <div className="error center">
                <div className="error__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    viewBox="0 0 24 24"
                    height="24"
                    fill="none"
                  >
                    <path
                      fill="#393a37"
                      d="m13 13h-2v-6h2zm0 4h-2v-2h2zm-1-15c-1.3132 0-2.61358.25866-3.82683.7612-1.21326.50255-2.31565 1.23915-3.24424 2.16773-1.87536 1.87537-2.92893 4.41891-2.92893 7.07107 0 2.6522 1.05357 5.1957 2.92893 7.0711.92859.9286 2.03098 1.6651 3.24424 2.1677 1.21325.5025 2.51363.7612 3.82683.7612 2.6522 0 5.1957-1.0536 7.0711-2.9289 1.8753-1.8754 2.9289-4.4189 2.9289-7.0711 0-1.3132-.2587-2.61358-.7612-3.82683-.5026-1.21326-1.2391-2.31565-2.1677-3.24424-.9286-.92858-2.031-1.66518-3.2443-2.16773-1.2132-.50254-2.5136-.7612-3.8268-.7612z"
                    ></path>
                  </svg>
                </div>
                <div className="error__title">
                  La licenza è in scadenza! Mancano solo {daysRemaining} giorni.
                </div>
                <div className="error__close"></div>
              </div>
            </div>
          </Row>
        </>
      )}
      {sizeRemaining < 50 && sizeVisible && (
        <>
          <Row className="firstDodox">
            <div className="Dodox2">
              <div className="error center">
                <div className="error__icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    viewBox="0 0 24 24"
                    height="24"
                    fill="none"
                  >
                    <path
                      fill="#393a37"
                      d="m13 13h-2v-6h2zm0 4h-2v-2h2zm-1-15c-1.3132 0-2.61358.25866-3.82683.7612-1.21326.50255-2.31565 1.23915-3.24424 2.16773-1.87536 1.87537-2.92893 4.41891-2.92893 7.07107 0 2.6522 1.05357 5.1957 2.92893 7.0711.92859.9286 2.03098 1.6651 3.24424 2.1677 1.21325.5025 2.51363.7612 3.82683.7612 2.6522 0 5.1957-1.0536 7.0711-2.9289 1.8753-1.8754 2.9289-4.4189 2.9289-7.0711 0-1.3132-.2587-2.61358-.7612-3.82683-.5026-1.21326-1.2391-2.31565-2.1677-3.24424-.9286-.92858-2.031-1.66518-3.2443-2.16773-1.2132-.50254-2.5136-.7612-3.8268-.7612z"
                    ></path>
                  </svg>
                </div>
                <div className="error__title">
                  Sta esaurendo lo Spazio! Hai solo {sizeRemaining} Mb.
                </div>
                <div className="error__close"></div>
              </div>
            </div>
          </Row>
        </>
      )}
      {studio.fbSize && studio.fbSizeMax && (
        <>
          <Row className="space"></Row>

          <div className="spacez"></div>

          <div className="centered">
            <Row className="centered thecircle">
              <Col span={4}></Col>
              <Col ref={ref1} span={4}>
                <h2>Spazio Occupato</h2>
                <Space wrap>
                  <Progress
                    className="percent thecirclo"
                    type="circle"
                    percent={Math.round(
                      (studio.fbSize / studio.fbSizeMax) * 100
                    )}
                    strokeColor={{ "0%": "#9fddc5", "100%": "#a785a9" }}
                  />
                </Space>

                <h5>
                  {studio.fbSize.toFixed(1)} MB / {studio.fbSizeMax.toFixed(1)}{" "}
                  MB
                </h5>
              </Col>
              <Col ref={ref2} span={8}>
                <Statistic
                  className="thecirclex"
                  title="Pazienti Totali"
                  value={PatientX}
                />
              </Col>

              <Col ref={ref3} span={4}>
                <h2>Licenza: {licenseStatus}</h2>
                <Space wrap>
                  <Progress
                    className="thecirclo"
                    type="circle"
                    percent={percentComplete}
                    strokeColor={{ "0%": "#9fddc5", "100%": "#6cdbd9" }}
                    status="active"
                  />
                </Space>
                <h5>Hai ancora {daysRemaining} giorni.</h5>
              </Col>
            </Row>
          </div>

          <Row className="space"></Row>
        </>
      )}
      {width > 768 && (
        <>
          <Row className="spaceOnTop">
            <Col span={0} />
            <Col ref={ref4} span={10} className="centered">
              {newPatient}
            </Col>
            <Col ref={ref5} span={10} className="centered">
              {newExam}
            </Col>
            <Col span={0} />
            <Col className="sapceai" span={24}></Col>
          </Row>
          <Popover
            placement="leftBottom"
            title="Hai Bisogno Di Aiuto?"
            content={contentx}
          >
            <FloatButton
              icon={<QuestionCircleOutlined rev={undefined} />}
              type="default"
              style={{ right: 24 }}
            />
          </Popover>
        </>
      )}
      {width <= 768 && (
        <>
          <div
            className="centered smaller spaceOnTop"
            style={{ marginBottom: "16px" }}
          >
            {newPatient}
          </div>
          <div className="centered smaller spaceOnTop">{newExam}</div>
          <Popover
            placement="leftBottom"
            title="Hai Bisogno Di Aiuto?"
            content={contentx}
          >
            <FloatButton
              icon={<QuestionCircleOutlined rev={undefined} />}
              type="default"
              style={{ right: 24 }}
            />
          </Popover>
        </>
      )}

      {sizeRemaining !== undefined && sizeRemaining < 30 && (
        <>
          <Button className="updateplan" href={"/app" + HOME_PATH + PRICE_PATH}>
            <h5>Aggiorna il tuo piano Adesso!</h5>
          </Button>
        </>
      )}
      {daysRemaining !== undefined && daysRemaining < 16 && (
        <>
          <Button className="updateplan" href={"/app" + HOME_PATH + PRICE_PATH}>
            <h5>Aggiorna il tuo piano Adesso!</h5>
          </Button>
        </>
      )}
      {<div className="centered-end"></div>}
    </>
  );
};

export default Home;
